import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  toggle(e) {
    e.preventDefault()
    window.Beacon("toggle")
  }
}
